import React from "react";
import PropTypes from "prop-types";
import RetirementGuidanceCard from "../../../../../atoms/retirement-guidances-card";

import styles from "./styles.m.css";
import { get } from "lodash";

const RetirementGuideLines = props => {
  const story = get(props.collection, ["items"], null);
  const stories = story && story !== undefined ? story.map(item => item.story) : [];

  const slides =
    stories &&
    stories !== undefined &&
    stories.map(item => <RetirementGuidanceCard key={item.id} story={item} className={styles.card} />);
  return stories.length ? (
    <div className={`${styles.base}`}>
      {props.collection.name && (
        <h4 className={`${styles.headline}`}>
          <span>{"ஓய்வுகால வழிகாட்டல்கள்"}</span>
        </h4>
      )}
      <div className={styles["stories-container"]}>{slides}</div>
    </div>
  ) : null;
};

RetirementGuideLines.propTypes = {
  className: PropTypes.string,
  CrStory: PropTypes.object,
  collection: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    items: PropTypes.array
  }),
  numberOfCardsInViewDesktop: PropTypes.number,
  numberOfCardsInViewTablet: PropTypes.number,
  numberOfCardsInViewMobile: PropTypes.number
};

export default RetirementGuideLines;
